<!--联系我们 通用组件-->
<template>
  <div class="contact-us">
    <div>
      <div>
        <div>联系我们</div>

        <div>
          <div>
            <input placeholder="请输入您的姓名" maxlength="20" v-model="form.username"/>
            <input placeholder="请输入您的地址" maxlength="100" v-model="form.address"/>
            <input placeholder="请输入您的电话号码，以便于我们更好联系您" maxlength="11" v-model="form.phone"/>
          </div>

          <div>
            <textarea placeholder="请详细填写一下您的需求，以便我我们对您的需求更好的了解，以便于更好的为您提供服务！" maxlength="500"
                      v-model="form.content"></textarea>
          </div>
        </div>

        <div>一个新的需求、从这里开始、欢迎填写表格发送合作邮件至：{{ company.email }}</div>

        <div>
          <div @click="submit">提交</div>
        </div>
      </div>

      <div @click="updateShowState(false)">×</div>
    </div>
  </div>
</template>

<script>
import {company} from '@/global/constant'
import {useStore} from 'vuex'
import {save} from "@/api/contactUs"

const {ElMessage} = require("element-plus")

export default {
  name: "ContactUs",
  setup() {
    const store = useStore()

    const form = {
      username: undefined,
      address: undefined,
      phone: undefined,
      content: undefined
    }

    const resetForm = () => {
      form.username = undefined
      form.address = undefined
      form.phone = undefined
      form.content = undefined
    }
    resetForm()

    const updateShowState = (e) => {
      resetForm()
      store.commit('updateContactUsShow', e)
    }

    const submit = () => {
      if (form.username === undefined || form.username === '') {
        ElMessage({
          message: '请输入姓名',
          type: 'warning'
        })
      } else if (form.phone === undefined || form.phone === '') {
        ElMessage({
          message: '请输入联系电话',
          type: 'warning'
        })
      } else if (form.content === undefined || form.content === '') {
        ElMessage({
          message: '请填写留言',
          type: 'warning'
        })
      } else {
        save(form).then(() => {
          store.commit('updateContactUsShow', false)
          resetForm()
          ElMessage({
            message: '提交成功',
            type: 'success'
          })
        })
      }
    }

    return {
      submit,
      company,
      updateShowState,
      form
    }
  }
}
</script>

<style scoped>
.contact-us {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.42);
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-us > div {
  width: 50%;
  height: 60%;
  opacity: 0.95;
  background: #dde2ec;
  padding: 5%;
  display: flex;
  align-items: center;
  position: relative;
}

.contact-us > div > div:nth-child(1) {
  width: 100%;
}

.contact-us > div > div:nth-child(1) > div:nth-child(1) {
  font-family: PingFangSC-Semibold;
  font-size: 36px;
  color: #000000;
  letter-spacing: 0;
  line-height: 36px;
  text-align: center;
}

.contact-us > div > div:nth-child(1) > div:nth-child(2) {
  margin-top: 50px;
}

.contact-us > div > div:nth-child(1) > div:nth-child(2) > div:nth-child(1) {
  display: inline-block;
  width: 48%;
  margin-right: 2%;
}

.contact-us > div > div:nth-child(1) > div:nth-child(2) > div:nth-child(2) {
  display: inline-block;
  width: 50%;
}

.contact-us > div > div:nth-child(1) > div:nth-child(2) > div:nth-child(1) {
  vertical-align: top;
}

.contact-us > div > div:nth-child(1) > div:nth-child(2) > div:nth-child(1) > input {
  width: 100%;
  height: 50px;
  background: #ffffff;
}

.contact-us > div > div:nth-child(1) > div:nth-child(2) > div:nth-child(1) > input:not(:first-child) {
  margin-top: 20px;
}

.contact-us > div > div:nth-child(1) > div:nth-child(2) > div:nth-child(2) {
  height: 192px;
}

.contact-us > div > div:nth-child(1) > div:nth-child(2) > div:nth-child(2) > textarea {
  width: 100%;
  height: 100%;
  border: none;
  background: #ffffff;
}

input, textarea {
  /*去除阴影*/
  box-shadow: none;
  /*去除边框*/
  border: none;
  /*去除聚焦input的蓝色边框*/
  outline: none;
  /*禁止拖拽*/
  resize: none;
  /*去除iOS默认样式*/
  -webkit-appearance: none;
  /*去除点击时背景高亮样式*/
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

input::-webkit-input-placeholder { /* WebKit browsers*/
  color: #848997;
  text-indent: 10px;
}

input:-moz-input-placeholder { /* Mozilla Firefox 4 to 18*/
  color: #848997;
  text-indent: 10px;
}

input::-moz-input-placeholder { /* Mozilla Firefox 19+*/
  color: #848997;
  text-indent: 10px;
}

input:-ms-input-placeholder { /* Internet Explorer 10+*/
  color: #848997;
  text-indent: 10px;
}

textarea::-webkit-input-placeholder {
  color: #848997;
  padding: 10px;
}

.contact-us > div > div:nth-child(1) > div:nth-child(3) {
  margin-top: 30px;
  font-family: PingFangSC-Regular;
  font-size: 15px;
  font-weight: 300;
  color: #3470FF;
}

.contact-us > div > div:nth-child(1) > div:nth-child(4) {
  text-align: center;
  margin-top: 30px;
}

.contact-us > div > div:nth-child(1) > div:nth-child(4) > div {
  width: 130px;
  height: 50px;
  line-height: 50px;
  background: #3470FF;
  border-radius: 12px;
  color: #ffffff;
  font-family: PingFangSC-Medium;
  font-size: 18px;
  margin: 0 auto;
  cursor: pointer;
}

.contact-us > div > div:nth-child(2) {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 30px;
  cursor: pointer;
}
</style>